import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=973c61f4&scoped=true&"
import script from "./back-to-top.vue?vue&type=script&lang=js&"
export * from "./back-to-top.vue?vue&type=script&lang=js&"
import style0 from "./back-to-top.vue?vue&type=style&index=0&id=973c61f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c61f4",
  null
  
)

export default component.exports